import React from 'react';

const ProductPagination = ({ pagination, onPageChange }) => {
  return (
    <div className="flex justify-center items-center mt-5 gap-3">
      <button
        onClick={() => onPageChange(1)}
        disabled={!pagination.has_prev}
        className="bg-slate-500 hover:bg-slate-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-3 py-2 rounded text-sm transition-colors"
      >
        {'<<'}
      </button>
      <button
        onClick={() => onPageChange(pagination.page - 1)}
        disabled={!pagination.has_prev}
        className="bg-slate-500 hover:bg-slate-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-3 py-2 rounded text-sm transition-colors"
      >
        {'<'}
      </button>
      <button
        onClick={() => onPageChange(pagination.page + 1)}
        disabled={!pagination.has_next}
        className="bg-slate-500 hover:bg-slate-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-3 py-2 rounded text-sm transition-colors"
      >
        {'>'}
      </button>
      <button
        onClick={() => onPageChange(pagination.pages)}
        disabled={!pagination.has_next}
        className="bg-slate-500 hover:bg-slate-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-3 py-2 rounded text-sm transition-colors"
      >
        {'>>'}
      </button>
      <span className="mx-4 text-sm text-gray-600">
        {pagination.page} / {pagination.pages} (총 {pagination.total}개)
      </span>
    </div>
  );
};

export default ProductPagination;
